import { routerStore } from 'core/routing';

import { clientStore } from 'apps/client/app';
import { headerStore } from 'apps/components/header/app';
import { frameStore } from 'apps/components/Frame/appManager';

// import { manufacturerListingManager } from 'apps/manufacturing/appManager';
import { searchManager } from 'apps/search/appManager';
import { notificationCenter } from 'apps/notificationCenter/appManager';
import { ProcessMonitorAppManager } from 'apps/processMonitor/appManager';

import { stripeStore } from 'apps/payment/stripe';
import { conversionsStore } from 'apps/conversions/appManager';

// FIXME - Reorg so managers are only active if being used
class RootStore {
  stores = {};
  disposers = []; // to handle parent disposer code from the ProcessMonitorAppManager

  constructor() {
    // this.stores.manufacturerListingManager = manufacturerListingManager;
    this.stores.searchManager = searchManager;
    this.stores.notificationCenter = notificationCenter;
    this.stores.processMonitor = new ProcessMonitorAppManager(this);
    this.stores.routerStore = routerStore;
    this.stores.clientStore = clientStore;
    this.stores.headerStore = headerStore;
    this.stores.stripeStore = stripeStore;
    this.stores.frameStore = frameStore;
    this.stores.conversionsStore = conversionsStore;
  }
}

export const rootStore = new RootStore();
